import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import router from '@/router'
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
// import '@/style/reset.css'
import '@/style/index.scss'
import 'element-ui/lib/theme-chalk/index.css';
import navigationBar from '@/components/navigation.vue'
import informationBar from '@/components/informationBar.vue'
import banner from './components/banner.vue'
import headline from './components/headline.vue'
import i18n from './i18n/index.js';// 引入i18n实例


import VueMeta from 'vue-meta'

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true // 切换页面时刷新 head 信息
})
import {
  Button, Menu, MenuItem,
  MenuItemGroup,
  Submenu,
  Carousel,
  CarouselItem,
  Drawer,Pagination,
  Message,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Collapse,
  CollapseItem,
  Input,
  Form,
  FormItem,
  Table,
  TableColumn,

} from 'element-ui';
import VueSmoothScroll from "vue2-smooth-scroll";
import Viewer from 'v-viewer'   //引入命令
import 'viewerjs/dist/viewer.css'   //引入css样式
import store from '@/store'
import VueCountrySelect from 'vue-country-select-2';

Vue.use(VueCountrySelect);
Vue.use(Viewer)   //全局使用


Viewer.setDefaults({    //设置初始值
    Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})


Vue.config.productionTip = false
// Vue.use(preview)
Vue.use(VueSmoothScroll)
Vue.use(VueRouter)
Vue.use(Button);
Vue.use(Menu);
Vue.use(Pagination);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Drawer);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Input);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Table);
Vue.use(TableColumn);
Vue.component('navigationBar', navigationBar)
Vue.component('informationBar', informationBar)
Vue.component('banner', banner)
Vue.component('headline', headline)
Vue.component('VueCountrySelect', VueCountrySelect)
Vue.prototype.$message = Message;


Vue.directive('title',{
  inserted:function(el,binding){
      document.title = el.dataset.title
  }
})

 


new Vue({
  store,
  router,
  i18n,
  beforeCreate() {
    Vue.prototype.$bus = this //安装全局事件总线，$bus就是当前应用的vm
  },
  render: h => h(App),
}).$mount('#app')

// const Demo = Vue.extend({});
// const d = new Demo();
// Vue.prototype.x = d;
